import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import logoImage from "@/assets/logo-corre-digital.png";

export default function AlunoLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const next = new URLSearchParams(window.location.search).get("next");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email.trim() || !senha.trim()) {
      setError("Informe seu e-mail e senha");
      return;
    }

    setIsLoading(true);
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password: senha,
      });
      if (error) throw error;
      navigate(next || "/aluno");
    } catch (err: any) {
      setError(err.message || "Credenciais inválidas");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col px-6 py-6">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        className="flex items-center gap-4 mb-8"
      >
        <Button variant="ghost" size="icon" onClick={() => navigate(`/aluno/escolha${next ? `?next=${encodeURIComponent(next)}` : ""}`)}>
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <img src={logoImage} alt="Corre Digital" className="h-7" />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="flex-1 flex flex-col justify-center max-w-md mx-auto w-full"
      >
        <div className="mb-8">
          <h1 className="font-heading text-2xl font-bold text-foreground">Entrar na minha conta</h1>
          <p className="text-muted-foreground text-sm mt-1">Use seu e-mail e senha</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">E-mail</Label>
            <Input id="email" type="email" placeholder="seu@email.com" value={email}
              onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="space-y-2">
            <Label htmlFor="senha">Senha</Label>
            <Input id="senha" type="password" placeholder="Sua senha" value={senha}
              onChange={(e) => setSenha(e.target.value)} />
          </div>

          {error && (
            <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }}
              className="text-sm text-destructive text-center">{error}</motion.p>
          )}

          <div className="pt-4">
            <Button type="submit" variant="hero" size="xl" className="w-full" disabled={isLoading}>
              {isLoading ? (<><Loader2 className="w-5 h-5 animate-spin" />Entrando...</>) : "Entrar"}
            </Button>
          </div>
        </form>

        <p className="text-center text-sm text-muted-foreground mt-6">
          Não encontrou sua conta?{" "}
          <button onClick={() => navigate(`/aluno/cadastro${next ? `?next=${encodeURIComponent(next)}` : ""}`)} className="text-primary font-medium hover:underline">
            Criar perfil
          </button>
        </p>
      </motion.div>
    </div>
  );
}
